import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/auth.service';

/**
 * Role redirect guard that automatically redirects authenticated users to their appropriate dashboard
 * Used for root routes to prevent authenticated users from accessing auth pages
 */
export const roleRedirectGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If user is not authenticated, allow access to auth pages
  if (!authService.isAuthenticated()) {
    return true;
  }

  // If user is authenticated, redirect based on role
  const userRole = authService.getUserRole();
  
  switch (userRole) {
    case 'customer':
      return router.createUrlTree(['/customer/projects']);
    case 'admin':
      // Redirect admin users to customer list
      return router.createUrlTree(['/admin/customers']);
    default:
      // Unknown role, clear auth data and stay on auth page
      authService.clearTokens();
      return true;
  }
};